import * as React from 'react';
import './styles.css' ;
import GamePageLayout from '../../components/GamePageLayout';
import {useDispatch, useSelector} from "react-redux";
import GameNavbar from "../../components/GameNavbar";
import GameHeader from "../../components/GameHeader";
import {aboutUsDictionary} from "../../constants/aboutUs"
import {Button,Util} from "baziigram"

const AboutUs = () => {

const [language , setLanguage] = React.useState(null)
const [className , setClassName] = React.useState("rtl text-right")

React.useEffect(()=>{
setLanguage(Util.getLanguage())
if(language == "en")
setClassName("ltr text-left")
},[language])

const scrollToTeam=()=>{
 document.getElementById('team').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

}

  return (
      <GamePageLayout type={"ABOUT_US"}>

        <GameNavbar backUrl={"/"} page={"aboutUs"}/>
        <div className={"rtl"}>
         <GameHeader type={"ABOUT_US"}>
           <div className={"text_header text-center d-flex flex-column justify-content-center align-items-center"}>
                           <h1 className={"my-2"} >{aboutUsDictionary.phoenixTeam[language]}</h1>
                          <Button onClick={scrollToTeam} title={aboutUsDictionary.seeTeamMembers[language]}></Button>

                        </div>
         </GameHeader>

          <div id={"team"} className='main_container'>

           <div className={`${className} team-container`}>
                     <h2 className="mb-2 ">{aboutUsDictionary.aboutTeamTitle[language]}</h2>
                     <div dangerouslySetInnerHTML={{__html: aboutUsDictionary.aboutTeam[language]}} />
                     </div>

           <div className="d-flex flex-row justify-content-between rtl team-container align-items-center my-2">
           <img className="team-images" src="/images/AboutUs/bahar.png"/>
           <div className="flex-fill rtl text-right mr-2">
           <h2 className="mb-2 ">{aboutUsDictionary.bahar[language]}</h2>
           <h3>{aboutUsDictionary.baharPosition[language]}</h3>
           <h3>{aboutUsDictionary.baharEdu[language]} </h3>
           </div>
           </div>

           <div className={`${className} team-container`}>
                     <div className="d-flex flex-row justify-content-between align-items-center">
                      <div className="flex-fill rtl text-right mr-2">
                      <h2 className="mb-2">{aboutUsDictionary.radman[language]}</h2>
                      <h3>{aboutUsDictionary.radmanPosition[language]}</h3>
                      <h3>{aboutUsDictionary.radmanEdu[language]} </h3>

                      </div>
                       <img className="team-images" src="/images/AboutUs/radman.png"/>
                       </div>
                        <div className="mt-2" dangerouslySetInnerHTML={{__html: aboutUsDictionary.radmanInfo[language]}} />
                      </div>

              <div className={`${className} team-container`}>
                                 <div className="d-flex flex-row justify-content-between align-items-center">
                                  <img className="team-images" src="/images/AboutUs/aryan.png"/>
                                  <div className="flex-fill rtl text-right mr-2">
                                  <h2 className="mb-2 ">{aboutUsDictionary.aryan[language]}</h2>
                                  <h3 >{aboutUsDictionary.aryanPosition[language]}</h3>
                                   </div>
                                </div>
                                  <div dangerouslySetInnerHTML={{__html: aboutUsDictionary.aryanInfo[language]}} />

                                   </div>

             <div className={`${className} team-container`}>
                       <div className="d-flex flex-row justify-content-between align-items-center">
                        <div className="flex-fill rtl text-right mr-2">
                        <h2 className="mb-2 ">{aboutUsDictionary.sepehr[language]}</h2>
                        <h3 >{aboutUsDictionary.sepehrPosition[language]}</h3>
                        <h3>{aboutUsDictionary.sepehrEdu[language]} </h3>
                        </div>
                         <img className="team-images" src="/images/AboutUs/sepehr1.png"/>
                         </div>
                          <div dangerouslySetInnerHTML={{__html: aboutUsDictionary.sepehrInfo[language]}} />
                         </div>

          </div>


        </div>

      </GamePageLayout>
  )
}

export default AboutUs;
